<template>
    <div class="text-xs text-green-800 bg-green-50 rounded-full px-2 py-1">
        Course
    </div>
</template>
